module.exports = __webpack_public_path__ + "static/media/roboto-light-webfont.efcef5f1.ttf";